var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-list-group',[_c('template',{slot:"activator"},[_c('v-list-tile',[_c('v-list-tile-avatar',[_c('h-icon',[_vm._v(_vm._s(_vm.icon))])],1),_c('v-list-tile-title',[_vm._v(_vm._s(_vm.title))])],1)],1),_vm._t("default")],2)}
var staticRenderFns = []

export { render, staticRenderFns }